<script setup>
import { onMounted } from "vue";
import useMyToDoListTable from "./hooks/useMyToDoListTable";
import useMyToDoListAdjust from "./hooks/useMyToDoListAdjust";
import dealDialog from "./dealDialog.vue";

const {
  searchRef,
  searchData,
  tableLoading,
  tableData,
  columns,
  pages,
  getList,
  handleReset,
} = useMyToDoListTable();

const { adjustRef, handleDispose, handleReturn } = useMyToDoListAdjust(getList);

onMounted(() => {
  getList();
});
</script>

<template>
  <zh-table-page v-bind="{ title: '我的待办' }">
    <template #header-btn />
    <template #search>
      <el-form :model="searchData" ref="searchRef" :inline="true">
        <el-form-item prop="processName">
          <el-input v-model="searchData.processName" placeholder="流程名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="Search" @click="getList()"
            >搜索</el-button
          >
          <el-button icon="Refresh" @click="handleReset()">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template #table>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        v-loading="tableLoading"
      >
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            show-overflow-tooltip
          />
        </template>
        <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button type="primary" link @click="handleDispose(row)"
              >处理</el-button
            >
            <el-button type="primary" link @click="handleReturn(row)"
              >交还</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :total="pages.total"
        v-model:current-page="pages.page"
        @update:current-page="getList"
        layout="->, prev, pager, next"
      />
    </template>
  </zh-table-page>

  <deal-dialog ref="adjustRef" @after-save="getList" />
</template>

<style scoped></style>
